import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([

    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'name', 
        width: 200, 
        label: '测评依据'
    },
    {
        key:'choices', 
        label: '测评结果', 
        width: 300, 
        render: (data, column) => {
            if(column.type == 1 || column.type == 2) {
                return (
                    <ol className="upper-alpha">
                    {
                        data.map(d => (
                        <li>{d.label};
                            <span className="range">
                            分数范围:
                            <span className="min">{d.valueLow}</span> ~ <span className="max">{d.valueHigh}</span>
                            </span>
                        </li>
                        ))
                    }
                    </ol>
                )
            } else if(column.type == 3) {
                return "";
            } else if(column.type == 4) {
                return data.map((d, index) => {
                    let typeName = "文本输入框";
                    let type = d.type;
                    if(type === 'input-text') {
                        typeName = '文本输入框';
                    } else if(type === 'input-figure') {
                        typeName = '数字输入框';
                    } else if(type === 'textarea') {
                        typeName = '文本框';
                    }
                    let roleName = '未知';
                    if(d.role === 1) {
                        roleName = '学生或老师';
                    } else if(d.role === 2) {
                        roleName = '辅导员';
                    }
                    return (
                        <div>
                            标题{index + 1}：{ d.label }；
                            { d.defaultValue ? `默认值：${d.defaultValue}` : '' }
                            <Tag style={{marginLeft: 10, marginRight: 10}} color="blue"> { typeName } </Tag>
                            <Tag color="blue">{ roleName }</Tag>
                        </div>
                    )
                })
            } else if(column.type == 5 || column.type == 6) {
                return <ol className="upper-alpha">
                    {
                        data.map(d => {
                            return <li>
                                {d.view}
                            </li>
                        })
                    }
                </ol>
            }
         }
    },
    {
        key: 'type', 
        label: '题目类型', 
        render: (type) => {
            if(type == 1) {
                return '单选';
            } else if(type == 2) {
                return '多选';
            } else if(type == 3) {
                return '问答';
            } else if(type == 4) {
                return '填空';
            } else if(type == 5) {
                return '选择填空（单选）';
            } else if(type == 6) {
                return '选择填空（多选）';
            }
        } 
    },
    {
        key: 'isGoal',
        label: '是否是目标',
        render: (val) => {
            if(val === 1) {
                return '是';
            } else if(val === 2){
                return '否';
            } else {
                return '未知';
            }
        }
    },
    {
        key:'presetScore', 
        label: '默认预置分数'
    }
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('developsubitem/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('developsubitem/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: (item.choices || []).length * 30
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: (d.choices || []).length * 30
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));

        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('developsubitem/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '测评依据添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到测评依据管理页面！</p>
                    </div>
                ),
                onOk() {
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('developsubitem/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '测评依据更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到测评依据管理页面！</p>
                    </div>
                ),
                onOk() {
                    
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('developsubitem/delete/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    redirect
}